

import { cn } from "@/lib/utils";

interface ControlButtonProps {
  onClick: (e?: React.MouseEvent) => void;
  children: React.ReactNode;
  className?: string;
  active?: boolean;
  ariaLabel?: string;
  size?: 'small' | 'large';
}

const ControlButton = ({ 
  onClick, 
  children, 
  className,
  active = false,
  ariaLabel,
  size = 'small'
}) => {
  const handleClick = (e: React.MouseEvent) => {
    onClick(e);
  };

  return (
    <button
      onClick={handleClick}
      aria-label={ariaLabel}
      className={cn(
        "flex items-center justify-center text-white transition-all duration-200",
        size === 'large' 
          ? "w-14 h-14 sm:w-16 sm:h-16 bg-black/30 border border-white/30 rounded-full hover:bg-black/40"
          : "px-5 py-3 gap-2.5 text-sm font-light hover:bg-black/40 shadow-sm",
        active && "bg-black/40",
        className
      )}
      type="button"
    >
      {children}
    </button>
  );
};

export default ControlButton;
